import create from 'zustand'

import { generalStoreCreator } from './general.store'
import { tourStoreCreator } from './tour.store'
import { layoutStoreCreator } from './layout.store'

export const useStore = create((set) => ({
  ...generalStoreCreator(set),
  ...layoutStoreCreator(set),
  ...tourStoreCreator(set),
}))
